import React from 'react';
import './styles.css';

export default function ComingSoon({ title, description }) {
  return (
    <div className="panel placeholder-panel">
      <div className="placeholder-panel__icon">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M12 2l1.8 5.5L19 9l-5.2 1.5L12 16l-1.8-5.5L5 9l5.2-1.5L12 2z" />
        </svg>
      </div>
      <h3>{title} er under udvikling</h3>
      <p>{description}</p>
    </div>
  );
}
